export const LIST_KNOWLEDGE_PARTNER = `homepage/list-knowledge-partner`;
